import styled from 'styled-components/macro';
import { graySecondaryDark, grayLight } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import Icon from '../Icon';
import Dropdown from '../Dropdown';
import Arrow from '../Arrow';

export const ShareContainer = styled.div`
  position: relative;
  > .icon {
    ${fontSize(22)};
    height: 25px;
    cursor: pointer;
  }
`;

export const StyledDropdown = styled(Dropdown)`
  width: 180px;
  right: 0;
  margin-top: 15px;
  border-radius: 5px;
  overflow-y: visible;
`;

export const StyledArrow = styled(Arrow)`
  position: absolute;
  right: 10px;
  top: -20px;
  border-bottom-color: white;
`;

export const DropdownList = styled.ul`
  list-style: none;
`;

export const DropdownItem = styled.li`
  ${fontSize(14)};
  margin: 0px 25px;
  padding: 10px 5px;
  color: ${graySecondaryDark};
  border-bottom: solid 1px #e6e4e4;
  font-weight: bold;
  cursor: pointer;
  &:first-child {
    font-weight: normal;
    cursor: auto;
  }
  &:last-child {
    border-bottom: none;
  }
  &:active:not(:first-child) {
    color: ${grayLight};
  }
`;

export const ShareIcon = styled(Icon)`
  ${({ header }) => (header ? fontSize(25) : fontSize(18))};
  position: relative;
  z-index: 4;
  display: inline-block;
  cursor: pointer;
  margin-right: 10px;
  vertical-align: middle;
  color: ${({ theme }) => theme.primaryColor};
`;
